<template>
<div class="container-fluid">

    <div class="jumbotron">
  <h1 class="display-4">POIZON PRODUCTS PUSH ZONE</h1>
  <p class="lead">{{ msg }}</p>
  <hr class="my-4">
  <div v-if="response && Array.isArray(response)">
  <p>
    <ul id="example-1">
      <li v-for="item in response" :key="item.requestNo">
        {{ item }}
      </li>
    </ul>    
  </p>
  </div>
  <div v-else>
    <p style="color:red">
      {{ response }}
    </p>
  </div>
  <button v-if="company.Id == 26 && !bt_spinner2" :disabled="bt_spinner1" @click="pushProducts('pushAll')" class="btn btn-primary" type="button">
    PUSH ALL 
    <span v-if="bt_spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true">    
    </span>
  </button>
  <button v-if="company.Id == 26 && !bt_spinner1" :disabled="bt_spinner2" @click="pushProducts('pushIncrement')" class="btn btn-primary ml-3" type="button">
    PUSH INCREMENT 
    <span v-if="bt_spinner2" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true">    
    </span>
  </button>
</div>

<div v-if="1==0" class="progress" style="height: 20px;">
   
  <div v-if="1==0"  :class="`progress-bar bg-primary`"  role="progressbar" :style="{'width':getProgress}" >{{ getProgress }}</div>
  
</div>

<div class="mt-1 ml-4" v-if="successCount">
  <span style="font-size:1.3rem;" class="badge badge-pill badge-success">Success {{ successCount }} / {{ pushCount }}</span>
  
</div>

<div  class="mt-1 ml-4" v-if="failCount">
  <span  style="font-size:1.3rem;" class="badge badge-pill badge-danger">Fail {{ failCount }} </span>
  <p>
    <ul id="example-1">
      <li v-for="item,index in failMsg" :key="index">
        {{ item }}
      </li>
    </ul>    
  </p>
</div>


</div>

</template>

<script>
/*import axios              from 'axios'*/


import { mapGetters }     from 'vuex';


export default {
  
  data () {
    return {


        bt_spinner1 : false,
        bt_spinner2 : false,
        response   : [],
        msg        : '',
        progress   : 0,
        eventSource : '',
        type1        : '',
        type2        : '',
        failCount    : 0,
        successCount : 0,
        failMsg      : [],
        pushCount    : 0          


        

    }
  },
  computed: 
  {  
    ...mapGetters(['company']),     
    getProgress()
    {
      const p = this.progress
      return p + "%";
    }      

  },
      
  mounted()
  {
    
    
    //this.getData()

  },
  created()  
  {

    
  }, 
   beforeDestroy () {  
    if(this.eventSource)     
    {
      this.eventSource.close()
    }
    
  },
  
  methods: 
    {
      
          
     async pushProducts(type)
      {
        this.pushCount    = 0
        this.failMsg      = []
        this.progress     = 0 
        this.successCount = 0
        this.failCount    = 0
        this.msg          = 'Sincronizzazione prodotti in esecuzione ...'
        this.response     = []
        this.bt_spinner1  = type == 'pushAll' ? true : false
        this.bt_spinner2  = type == 'pushIncrement' ? true : false

        const timeout   = 180000
        let url         = ''
        if(this.company.Id == 26)
          {
            url    = process.env.VUE_APP_ROOT_API1 + 'sync/poizon/'+ type + '/26' 
          }
          else
          {
              url   =  ''
          }
              if(url)  
              {
                                
                  this.eventSource = new EventSource(url);

                  this.eventSource.onmessage = (event) => {
                  const data = event.data;
                  console.log('Received data: ' + data);
                  
                  const obj          = JSON.parse(data)
                  const times        = obj.times
                  
                  if(this.pushCount == 0)
                  {
                  
                    this.pushCount    = times
                  }
                  
                  
                  const progress     = obj.progress
                  this.progress      = Math.round((progress / times) * 100)
                  
                  if(obj.msg == 'OK')
                  {
                    this.successCount++
                  
                  }
                  else if(obj.msg != 'OK' && obj.msg != 'start' && obj.msg != 'stop')
                  {
                    this.failCount++
                    this.failMsg.push(obj.msg)
                  }
                  

                  if(obj.msg =='stop')
                  {
                      this.msg = ''
                      this.progress = 100
                      this.bt_spinner1 = false
                      this.bt_spinner2 = false
                      this.eventSource.close();
                  }
                  // Update the DOM or perform any other action with the received data
                  };

                 /* 
                axios.get(url,{timeout:timeout}
                
                ).then(res => {

                    console.log('PUSH ZONE RESPONSE',res.data)
                    this.response = res.data

                }).catch(error => {
                    console.log('PUSH ZONE RESPONSE ERROR',error)

                    if (error.response) 
                    {
                    
                        console.log('ERRORE PUSHING',error.response.status);
                        console.log('ERRORE PUSHING',error.response.data);
      
                        this.response = error.response.data
                        
                    }
                    else if (error.request) 
                    {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log('REQUEST ERROR',error.request);
                      this.response = 'NETWORK ERROR'

      
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
      this.response = error.message
      
    }
    



                    
                }).finally(() =>{
                    this.msg = ''
                    this.bt_spinner1 = false
                    this.bt_spinner2 = false
                }
                )*/

                
                
              }
                
                
                    
        }
        
















    
      },
    
    
      


        
    
        

      
    
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 500px;
overflow : auto;
}
.table-wrapper-scroll-y {
  display  : block;
}
a{
  font-family : 'Roboto Condensed';
  font-size   : 25px;
  color       : red
}

.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }

    .bold
    {
        font-weight  : bold;
    }
    input[type=number] {
    border: 1px solid;
 
}
</style>